import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PageTitle from "shared/ui/PageTitle";
import CustomAccordion from "shared/ui/CustomAccordion";
import PriceTable from "features/publicPages/components/PriceTable";

const advantages = [
    {
        id: "1",
        title: "100% românesc – aliniat programei școlare",
        content: "Întrebările din fiecare test sunt în acord cu programa școlară și acoperă 100% materia respectivă.",
    },
    {
        id: "2",
        title: "Brio® generează un raport de evaluare, iar elevul știe unde se situează în raport cu cei de vârsta lui",
        content: "100% competitiv – dupa principiile sistemelor internaționale (TIMSS, PISA).",
    },
    {
        id: "3",
        title: "Testele standardizate BRIO sunt obiective și imparțiale",
        content: "Fiecare test este alcătuit și evaluat de către sistem pe baza unei metodologii riguroase. Brio® este " +
            "singurul sistem 100% obiectiv din România, care arată exact ce știe și ce nu știe un elev din România, " +
            "eliminând subiectivismul sau erorile de evaluare.",
    },
    {
        id: "4",
        title: "Le oferiți elevilor și profesorilor acces la cel mai modern instrument educațional",
        content: "Testele Brio sunt concepute special pentru noile generații de elevi. Ele sunt digitale și permit " +
            "testarea rapidă la principalele materii școlare. Fiecare elev testat află care sunt punctele sale forte, " +
            "dar și ce lacune are, și cum le poate îndrepta. Elevii, părinții și profesorii au astfel o imagine reală a " +
            "nivelului de pregătire și pot anticipa pașii viitori. Iar pentru a monitoriza progresul, Brio permite " +
            "testarea repetată, fără ca întrebările să fie aceleași.",
    },
    {
        id: "5",
        title: "Creșteți notele la evaluarea națională și promovabilitatea la bac",
        content: "Cu testele Brio, vă puteți crea propriile examene de simulare. Ele vă vor indica pentru fiecare elev " +
            "rezultatele probabile și vă vor oferi indicații despre cum pot fi îmbunătățite aceste rezultate. Apoi, prin" +
            " testare repetată puteți verifica în ce măsură progresul necesar se întâmplă sau nu. Puteți organiza " +
            "sesiunile de testare în școală, cu profesorii, sau elevii se pot testa individual, acasă.",
    },
    {
        id: "6",
        title: "Arătați fiecărui elev ce loc ocupă la nivel național",
        content: "Testele Brio au fost etalonate (testate și organizate în funcție de dificultate) pe un număr de peste " +
            "60.000 de elevi. Aceștia au fost grupați în eșantioane reprezentative pentru România, de peste 5.000 de " +
            "elevi din fiecare clasă de la clasa I la clasa a XII-a. De aceea, Brio poate spune care este poziția unui " +
            "elev comparativ cu toți elevii români de aceeași clasă cu el și face acest lucru sub formă de centilă, o " +
            "informație prețioasă pentru elevi și părinți deopotrivă.",
    },
    {
        id: "7",
        title: "Puteți măsura performanța profesorilor",
        content: "Brio poate fi utilizat pentru a evalua performanța la nivel de an școlar, profesor, clasă sau " +
            "școală/ liceu. În funcție de nevoile dumneavoastră, vă putem ajuta să obțineți în urma testării cu Brio " +
            "acele informații de care aveți nevoie, prin analize și comparații care pot fi accesate doar de către " +
            "dumneavoastră.",
    },
    {
        id: "8",
        title: "Economisiți timp",
        content: "Testele Brio se pot completa de pe computerele din școală (dacă ele există) sau se pot aplica " +
            "individual de către fiecare elev, pe propriul computer de acasă. Scorarea este automată, așa că nu este " +
            "nevoie de implicarea profesorilor la corectură. În schimb, aceștia pot primi pe mail rapoartele cu " +
            "rezultatele fiecărui elev și ale întregii clase.",
    },
]

const AboutBrioSchools = () => {

    return (
        <Box component="main">
            <PageTitle>
                BRIO pentru Școli
            </PageTitle>
            <Typography variant="body1">
                Testele din platforma Brio® sunt adaptate la standardele naționale de evaluare (clasele I - VIII), fiind
                perfect comparabile între ele (fiecare test este unic, acesta nu se repetă niciodată). Notele obținute
                de către elevi pot fi notate în catalog.
            </Typography>
            <Typography variant="h3" mt={3} mb={3}>Avantajele BRIO pentru Școli</Typography>
            <Typography variant="body1" mb={3}>
                Brio este un instrument prin care puteți anticipa și crește performanța generală a elevilor, precum și
                rezultatele acestora la teze și/sau examenele de Evaluare Națională și Bacalaureat.
            </Typography>
            <Typography variant="body1" fontWeight={600}>
                Testele din platforma Brio® sunt diferite, dar perfect comparabile între ele (fiecare test este unic,
                acesta nu se repetă niciodată). Rezultatele obținute de către elevi pot fi notate în catalog.
            </Typography>

            {/*<CustomAccordion data={advantages}/>*/}

            <Typography variant="h3" mt={3} mb={3}>Raportul Brio®</Typography>
            <Typography variant="body1">
                Brio® oferă și evaluare, nu doar testare: după fiecare test vezi instant detaliile despre unde a greșit
                elevul sau ce nu a răspuns, precum și Raportul Brio®, care analizează în detaliu competențele elevului
                și oferă recomandări în legătură cu următorii pași de urmat.
            </Typography>
            <Typography variant="body1">
                După fiecare test finalizat, Brio® emite instant un raport care arată nivelul actual al elevului, dar și
                tipurile de exerciții sau probleme pe care trebuie să insiste pentru a ajunge la următorul nivel. În
                plus, profesorii/directorii vor putea descărca rapoarte consolidate pe clasă și/sau școală, reușind
                astfel să aibă o imagine clară asupra nivelului elevilor.
            </Typography>
            <Typography variant="h3" mt={3} mb={3}>Teste standardizate BRIO</Typography>

            <PriceTable/>
        </Box>
    )
}

export default AboutBrioSchools;